import { useQuery } from "react-query";

import { agencyQueryKeys } from "./queryKeys";
import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { IAgency } from "../../models/agency/Agency";

export function useAgency(agencyId: string) {
  const { get } = useApiHelper();

  const agency = useQuery({
    queryKey: agencyQueryKeys.single(agencyId),
    queryFn: () =>
      get(
        `/agency/${agencyId}`
      ) as unknown as IDefaultResponseWithData<IAgency>,
    refetchOnWindowFocus: false,
  });

  return {
    agency,
  };
}
